import { NgModule } from "@angular/core";

import { CoreCommonModule } from "@core/common.module";

import { MenuComponent } from "app/layout/components/menu/menu.component";
import { VerticalMenuModule } from "app/layout/components/menu/vertical-menu/vertical-menu.module";
import { HorizontalMenuModule } from "app/layout/components/menu/horizontal-menu/horizontal-menu.module";
import { NavbarModule } from "../navbar/navbar.module";

@NgModule({
  declarations: [MenuComponent],
  imports: [CoreCommonModule, VerticalMenuModule, HorizontalMenuModule, NavbarModule],
  exports: [MenuComponent],
})
export class MenuModule {}
